import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase.js';
import { lastNDates } from '../../lib/dates.js';
import {
  morningBriefingStreak,
  checkoutStreak,
  devotionalStreak,
  workoutStreak,
} from '../../lib/streaks.js';

// Slim 4-stat row for Full Dash. Heatmap lives on Morning Briefing only.
export default function CondensedStreaks() {
  const [briefings, setBriefings] = useState([]);
  const [checkouts, setCheckouts] = useState([]);

  useEffect(() => {
    const since = lastNDates(35).slice(-1)[0];

    Promise.all([
      supabase
        .from('daily_briefing')
        .select('date, devotional, workout, completed_at')
        .gte('date', since),
      supabase
        .from('daily_checkout')
        .select('date, completed_at')
        .gte('date', since),
    ]).then(([{ data: b }, { data: c }]) => {
      setBriefings(b ?? []);
      setCheckouts(c ?? []);
    });
  }, []);

  const stats = [
    { label: 'Brief', count: morningBriefingStreak(briefings) },
    { label: 'Check-out', count: checkoutStreak(checkouts) },
    { label: 'Devo', count: devotionalStreak(briefings) },
    { label: 'Workout', count: workoutStreak(briefings) },
  ];

  return (
    <div className="bg-bg-card border border-border-base rounded p-5">
      <h3 className="text-xs uppercase tracking-wider text-text-secondary mb-3">
        🔥 Streaks
      </h3>
      <div className="grid grid-cols-4 gap-3">
        {stats.map((s) => (
          <div key={s.label} className="text-center">
            <div className="text-xl font-bold text-text-primary">{s.count}</div>
            <div className="text-[10px] uppercase tracking-wide text-text-muted mt-0.5">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
